<template>
  <div class="order-related">
    <span class="order-related__label input__label">
      {{ labelText }}
    </span>

    <div class="order-related__list">
      <span
          class="order-related__link"
          v-for="(order, i) in orders"
          :key="order.id"
          @click="$emit('clickOrder', order.id)"
      >
        {{ order.number }}{{ i + 1 === orders.length ? '' : ',' }}
      </span>
    </div>
  </div>
</template>

<script>
import {goToOrder} from "@/utils/router";

export default {
  props: {
    orders: {
      type: Array,
      required: false,
      default: () => {}
    },
    typeOrderRelated: {
      type: String,
      required: true,
      validator(value) {
        return ['parent', 'return'].includes(value)
      }
    }
  },

  computed: {
    labelText () {
      switch (this.typeOrderRelated) {
        case 'parent': return 'Создана из заявки:'
        case 'return': return 'Заявки на обмен/возврат:'
      }
      return ''
    }
  },

  methods: {
    goToOrder
  }
}
</script>

<style lang="scss" scoped>
.order-related {
  display: flex;
  flex-direction: column;

  &__label {
    cursor: default;
  }

  &__list {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  &__link {
    color: $orange;
    cursor: pointer;

    &:hover {
      color: #d26d0a;
    }
  }
}
</style>
